module.exports = __webpack_public_path__ + "assets/icons/waiting-emoji.gif";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/waiting-emoji.gif
// module id = ./src/styles/icons/emojies/waiting-emoji.gif
// module chunks = 0